export const creditCardOptions = [
  {
    value: 'AmEx',
    display: 'American Express',
    regex: new RegExp('^3[47][0-9]{0,}$'), //34, 37
  },
  {
    value: 'MasterCard',
    display: 'Mastercard',
    regex: new RegExp(
      '^(5[1-5]|222[1-9]|22[3-9]|2[3-6]|27[01]|2720)[0-9]{0,}$'
    ), //2221-2720, 51-55
  },
  {
    value: 'VISA',
    display: 'Visa',
    regex: new RegExp('^4[0-9]{0,}$'), //4
  },
  {
    value: 'Unknown',
    display: 'Unknown',
    regex: null,
  },
];
